<template>
    <el-drawer
        title="选择歌曲(最多选择10首)"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <div class="color-regular">在小站上传过的歌曲会出现在这里供选择</div>
            <el-checkbox-group v-model="checkedIds" :max="10" size="medium">
                <!-- <el-row :gutter="20" class="MT20">
                    <span v-for="v in musicList" :key="v.id" >
                        <el-checkbox :label="v.id" border>{{v.name}}</el-checkbox>
                    </span>
                </el-row> -->
                <div v-for="(item,index) in musicList" :key="index">
                    <!-- <h2 class="userName">{{item.idNameVO && item.idNameVO.name}}</h2> -->
                    <el-row :gutter="40">
                        <el-col v-for="v in item.musicListVOS" :key="v.id" :xs="24" :sm="12" :md="8" class="MT20">
                            <el-checkbox :label="v.id" >{{v.name}}</el-checkbox>
                        </el-col>
                    </el-row>
                </div>
            </el-checkbox-group>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submit()" :loading="btnLoading"
                >确 定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        musicIds:{
            type: Array,
            default: () => []
        },
        musics:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            musicList:null,
            checkedIds:[]
        }
    },
    created(){
        this.getData();
    },
    methods:{
        close() {
            this.drawerShow = false;
        },
        show(){
            this.checkedIds = this.musicIds;
            this.drawerShow = true;
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/performer/musicList",
                data: { pageNo: 1, pageSize: 100,id: this.userId},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.musicList = result.result;
                    } else {
                        self.$message.error(msg || "获取歌曲作品失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("获取歌曲作品失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        submit(){
            this.$emit('update:musicIds',[...this.checkedIds]);
            const _arry = [...this.musics] || [];
            this.musicList.forEach(item => {
                item.musicListVOS.forEach( a => {
                    this.checkedIds.forEach( v => {
                        if(a.id === v){
                            if(!this.musics.find(x => x.musicId == a.id)){
                                _arry.push({
                                    musicId: a.id,
                                    musicName: a.name,
                                });
                            }
                            
                        }
                    })
                })
            })
            this.$emit('update:musics',[..._arry]);
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>

</style>